import ErrorBoundary from 'sharedComponents/ErrorBoundary';
import { lazy, Suspense } from 'react';
import { Spinner } from '@7shifts/sous-chef';

const DashboardPage = lazy(() => import('./pages/DashboardPage'));

export const ROUTES = [
    {
        path: '/dashboard',
        element: (
            <Suspense fallback={<Spinner block />}>
                <DashboardPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    }
];
